function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}"));

function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    style: {
      animation: "rotate 2s linear infinite",
      zIndex: 2,
      position: "absolute",
      top: "50%",
      left: "50%",
      margin: "-25px 0 0 -25px",
      width: 50,
      height: 50
    }
  }, props), _ref, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 20,
    fill: "none",
    strokeWidth: 3,
    style: {
      animation: "dash 1.5s ease-in-out infinite"
    },
    stroke: "#000"
  }));
}

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg class='spinner' viewBox='0 0 50 50'%3E %3Cdefs%3E %3Cstyle type='text/css'%3E%3C!%5BCDATA%5B .spinner %7B animation: rotate 2s linear infinite; z-index: 2; position: absolute; top: 50%25; left: 50%25; margin: -25px 0 0 -25px; width: 50px; height: 50px; %7D .path %7B stroke: %23000000; animation: dash 1.5s ease-in-out infinite; %7D @keyframes rotate %7B 100%25 %7B transform: rotate(360deg); %7D %7D @keyframes dash %7B 0%25 %7B stroke-dasharray: 1, 150; stroke-dashoffset: 0; %7D 50%25 %7B stroke-dasharray: 90, 150; stroke-dashoffset: -35; %7D 100%25 %7B stroke-dasharray: 90, 150; stroke-dashoffset: -124; %7D %7D %5D%5D%3E%3C/style%3E %3C/defs%3E %3Ccircle class='path' cx='25' cy='25' r='20' fill='none' stroke-width='3'%3E%3C/circle%3E %3C/svg%3E";
export { SvgLoader as ReactComponent };